@if (patient) {
  <app-patient-form
    [patient]="patient"
    action="{{ 'edit' | translate }}"
    (close)="closeForm($event)">
  </app-patient-form>
}
